import React from 'react';
import axios from 'axios';
import ActivityLog from './activityLog';
import { AppPage, AppPageHeader } from "../../components/common/appShell";

function getActivityFilterFromLocation() {
  if (typeof window === 'undefined') {
    return '';
  }

  return new URLSearchParams(window.location.search).get('action') || '';
}

export default class LoggingUserLogs extends React.Component {
  state = {
    page: 1,
    limit: 20,
    query: '',
    searchText: '',
    activityFilter: getActivityFilterFromLocation(),
    exportingCsv: false,
  };

  componentDidMount() {
    this.fetchPage(1);
  }

  fetchPage = (page, stateOverrides = {}) => {
    const { fetchResourcePaginate, queryParams = {} } = this.props;
    const nextState = { ...this.state, ...stateOverrides, page };
    const { limit, query, activityFilter } = nextState;
    this.setState({ page, ...stateOverrides });
    fetchResourcePaginate('activity', undefined, {
      page,
      limit,
      search: query || '',
      action: activityFilter || '',
      ...queryParams,
    });
  };

  handleSearch = (text) => {
    this.fetchPage(1, { query: text, searchText: text });
  };

  handleFilter = (val) => {
    this.fetchPage(1, { activityFilter: val });
  };

  handleClearFilters = () => {
    this.fetchPage(1, { query: '', searchText: '', activityFilter: '' });
  };

  buildQueryParams = ({ includePagination = true } = {}) => {
    const { queryParams = {} } = this.props;
    const params = {
      search: this.state.query || '',
      action: this.state.activityFilter || '',
      ...queryParams,
    };

    if (includePagination) {
      params.page = this.state.page;
      params.limit = this.state.limit;
    }

    return params;
  };

  handleExportCsv = async () => {
    if (this.state.exportingCsv) {
      return;
    }

    this.setState({ exportingCsv: true });
    try {
      const res = await axios.get('/v2/activity/export', {
        params: this.buildQueryParams({ includePagination: false }),
        responseType: 'blob',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      });
      const blob = new Blob([res.data], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      link.href = url;
      link.download = `activity-log-${timestamp}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Failed to export activity log CSV', error);
    } finally {
      this.setState({ exportingCsv: false });
    }
  };

  render() {
    const {
      activityPages = [],
      activityMeta = {},
      activityPageLoading = {},
      outlets,
      devices,
      devicesLoading,
    } = this.props.resources;

    const currentPage = activityPages.find((p) => p.page === this.state.page) || {};
    const activity = currentPage.activity || [];
    const loading = !!activityPageLoading[this.state.page];

    return (
      <AppPage>
        <AppPageHeader
          title="Activity log"
          description="Review user, device, outlet, and firmware activity in one place. Search by device or serial number and filter the feed by activity type."
        />
        <ActivityLog
          activity={activity}
          outlets={outlets}
          devices={devices}
          devicesLoading={devicesLoading}
          loading={loading}
          refresh={() => this.fetchPage(this.state.page)}
          searchActivity={this.handleSearch}
          initialActivityFilter={this.state.activityFilter}
          onFilter={this.handleFilter}
          onClearFilters={this.handleClearFilters}
          onExportCsv={this.handleExportCsv}
          exportingCsv={this.state.exportingCsv}
          meta={activityMeta}
          page={this.state.page}
          onPageChange={this.fetchPage}
        />
      </AppPage>
    );
  }
}
